var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"fluid":""}},[_c('b-modal',{attrs:{"id":"deleteUrlSource","title":"Apagar Fonte"},on:{"ok":_vm.DeleteUrlSouce}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_vm._v("Tem a certeza que pretende eliminar esta fonte ?")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7885611c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sources/DeleteUrl.vue
// module id = lbrL
// module chunks = 1